/**
 * @fileoverview Various vector utility.
 * @license Apache-2.0
 */

/** v128 zero constant. */
export const v128_zero = new Uint8Array(16);
